export var linear = function linear(t) {
  return +t;
};